import React, { useEffect, useRef } from 'react';
import bgvideo from '../images/homevideo_bg.webp';
import AnimatedText from './AnimatedText';

const VideoComponent = () => {
    const videoRef = useRef(null);
    const reelClickedRef = useRef(false);

    useEffect(() => {
        const videoElement = videoRef.current;

        if (!videoElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        videoElement.play();
                        document.body.classList.add('siteOnVideo');
                    } else {
                        videoElement.pause();
                        document.body.classList.remove('siteOnVideo');
                    }
                });
            },
            { threshold: 0.25 }
        );

        observer.observe(videoElement);

        return () => {
            observer.unobserve(videoElement);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (reelClickedRef.current) {
                if (window.scrollY < 50) {
                    document.body.classList.add('bodyOnReel');
                } else {
                    document.body.classList.remove('bodyOnReel');
                    reelClickedRef.current = false;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const handleCloseClick = () => {
        document.body.classList.remove('bodyOnReel');
        reelClickedRef.current = false;
    };
    const handleReelClick = (e) => {
        e.preventDefault();
    
        const reelSection = document.querySelector('#reel');
        reelClickedRef.current = true;
    
        if (reelSection) {
            reelSection.scrollIntoView({ behavior: 'smooth' });
        }
    
        if (window.scrollY < 50) {
            document.body.classList.add('bodyOnReel');
        }
    };

    let videoURL = `${process.env.PUBLIC_URL}/videos/index-desktop.mp4`;
    let posterURL = `${process.env.PUBLIC_URL}/videos/index-desktop.webp`;

    return (
        <section className='videoHome' name='home'>
            <div className='trashHomeVideo' style={{ backgroundImage: `url(${bgvideo})` }}></div>
            <div className='buttonClose'onClick={handleCloseClick} >X cerrar</div>
            <div id="videoIndex" className="videoIndex">
                <video
                    ref={videoRef}
                    preload="metadata"
                    poster={posterURL}
                    width="400"
                    height="350"
                    muted
                    loop
                    playsInline
                >
                    <source src={videoURL} type="video/mp4" />
                </video>
            </div>
            <div className="homeText">
                <AnimatedText
                    lines={[
                        'INDEX® HELPS BRANDS',
                        'CONNECT W/ CULTURE ',
                    ]}
                    duration={20000}
                />
                <p className='videoBajada'>
                    <a href='#works' className='buttonIndex'>Works_</a>
                    <a href='#reel' className='buttonIndex buttonReel' onClick={handleReelClick}>Ver reel_</a>
                </p>
            </div>
        </section>
    );
};

export default VideoComponent;